import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TuneIcon from '@mui/icons-material/Tune';
import { mutationLabel } from './varianceActionDisplay.js';
import { productLabel } from './exportPreviewHelpers.js';

export const BooleanStatusIcon = ({ value, trueLabel, falseLabel }) => {
  const Icon = value ? CheckCircleIcon : CancelIcon;
  const label = value ? trueLabel : falseLabel;
  return (
    <Tooltip title={label}>
      <Box
        aria-label={label}
        role="img"
        sx={{
          alignItems: 'center',
          color: value ? 'success.main' : 'error.main',
          display: 'inline-flex',
          justifyContent: 'center',
          lineHeight: 0,
        }}
      >
        <Icon fontSize="small" />
      </Box>
    </Tooltip>
  );
};

export const MutationIcon = ({ mutation }) => {
  const normalized = String(mutation || '').toLowerCase();
  const meta = normalized === 'add'
    ? { Icon: AddCircleOutlineIcon, color: 'success.main' }
    : normalized === 'remove'
    ? { Icon: RemoveCircleOutlineIcon, color: 'error.main' }
    : normalized === 'replace'
    ? { Icon: SwapHorizIcon, color: 'warning.main' }
    : { Icon: TuneIcon, color: 'warning.main' };
  const label = mutationLabel(normalized || mutation);
  return (
    <Tooltip title={label}>
      <Box
        aria-label={label}
        role="img"
        sx={{ color: meta.color, display: 'inline-flex', lineHeight: 0 }}
      >
        <meta.Icon fontSize="small" />
      </Box>
    </Tooltip>
  );
};

export const ProductCodeCell = ({ row }) => {
  const code = productLabel(row);
  const name = row.productName || row.replacementProductName || '';
  return (
    <Tooltip title={name || code} describeChild>
      <Typography variant="body2" sx={{ fontWeight: 800, fontFamily: 'monospace' }}>
        {code}
      </Typography>
    </Tooltip>
  );
};

export const MetricBlock = ({ label, value, color = 'text.primary', helper = null }) => (
  <Box sx={{ minWidth: 130 }}>
    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 800, textTransform: 'uppercase' }}>
      {label}
    </Typography>
    <Typography variant="h6" sx={{ color, fontWeight: 900, lineHeight: 1.1 }}>
      {value}
    </Typography>
    {helper && (
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {helper}
      </Typography>
    )}
  </Box>
);
